import { Admin } from '@models/Admin'
import { Tenant } from '@models/Tenant'
import { APIResponse } from '@supplement-bacon/react-toolkit/models'
import axios from 'axios'
import Gleap from 'gleap'
import { IDENTITY_VERIFICATION_GLEAP_URL } from '../utils/urls'

/**
 * On Gleap side we use the same project for staging/production environments.
 * To avoid users mixing up between environments, we add the environment name as a prefix to the user id.
 */

/**
 * Gleap is only initialized when a project id is configured (see main.tsx), so
 * without it the SDK calls below are no-ops and the hash request is wasted.
 */
const isGleapEnabled = () => !!import.meta.env.VITE_GLEAP_PROJECT_ID

const GleapIdentify = async (admin: Admin, tenant: Tenant) => {
  if (!isGleapEnabled()) return

  const response = await identityVerificationGleap()
  const hash = response.data?.hash

  if (!hash) return

  Gleap.identify(
    admin.id.toString(),
    {
      name: `${admin.firstName} ${admin.lastName}`,
      email: admin.email,
      phone: admin.phone,
      // envName is unique and stable per tenant, so it keys the Gleap company.
      company: { id: tenant.envName, name: tenant.name },
      customData: { roles: JSON.stringify(admin.roles) },
    },
    hash
  )
}

const GleapRedactUser = () => {
  if (!isGleapEnabled()) return

  Gleap.clearIdentity()
}

const identityVerificationGleap: () => Promise<
  APIResponse<{ hash: string }>
> = () => axios.get(IDENTITY_VERIFICATION_GLEAP_URL).then((data) => data.data)

export { GleapIdentify, GleapRedactUser }
